if (!customElements.get("store-list")) {
  customElements.define(
    "store-list",
    class extends HTMLElement {
      constructor() {
        super();
        const storesList = this.querySelectorAll(".store");
        this.handleToggleStoreList();
        this.querySelector(".store-wrapper").addEventListener("click", (e) => {
          const store = e.target.closest(".store");
          if (store) {
            e.preventDefault();
            storesList.forEach((el) => el.removeAttribute("open"));
            store.setAttribute("open", "");
            this.handleAutoRenderEmbedMap(
              store.closest("[data-state-with-stores]"),
              store,
            );
          }
        });
      }

      handleToggleStoreList() {
        this.querySelector(".btn-container").addEventListener("click", (e) => {
          if (e.target.closest("[data-state]")) {
            const stateHandle = e.target
              .closest("[data-state]")
              .getAttribute("data-state");
            const storeGroups = this.querySelectorAll(
              `[data-state-with-stores]`,
            );
            const oneStoreGroup = this.querySelector(
              `[data-state-with-stores="${stateHandle}"]`,
            );
            storeGroups.forEach((el) => el.classList.add("hidden"));
            oneStoreGroup.classList.remove("hidden");
            const firstStore = oneStoreGroup.querySelector(".store");
            if (firstStore) {
              firstStore.setAttribute("open", "");
              this.handleAutoRenderEmbedMap(oneStoreGroup, firstStore);
            }
          }
        });
      }

      handleAutoRenderEmbedMap(wrapperElm, targetStore) {
        const embedMap = targetStore.getAttribute("data-embed-map");
        const mapContainer = wrapperElm.querySelector(".store-map");
        if (mapContainer) {
          if (embedMap) {
            const iframeHtmlElmStr = "<iframe " + embedMap + "></iframe>";
            mapContainer.innerHTML = iframeHtmlElmStr;
          } else {
            mapContainer.innerHTML = "";
          }
        }
      }
    },
  );
}
